import React from "react";
import { IconButton } from "@commonsku/design-system";
import { LuPencil } from "react-icons/lu";
import { WorkflowAutomationId } from "../../../types";
import { useNavigate } from "react-router-dom";

export interface AutomationEditButtonProps {
    workflowId: WorkflowAutomationId;
    disabled?: boolean;
}

const AutomationEditButton = ({ workflowId, disabled = true }: AutomationEditButtonProps) => {
    const navigate = useNavigate();
    const handleEdit = () => {
        navigate(`/automations/${workflowId}`);
    };

    return (
        <IconButton label="Edit automation" size="md" variant="ghost" onClick={handleEdit} disabled={disabled}>
            <LuPencil size={20} />
        </IconButton>
    );
};

export default AutomationEditButton;
